import React from 'react';

export const InfoIcon = (): JSX.Element => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 0C3.36 0 0 3.36 0 7.5 0 11.64 3.36 15 7.5 15c4.14 0 7.5-3.36 7.5-7.5C15 3.36 11.64 0 7.5 0zm-.75 12.75v-1.5h1.5v1.5h-1.5zm0-10.25V10h1.5V2.5h-1.5z"
        fill="#fff"
      />
    </svg>
  );
};
